import { createContext, useContext } from 'react';

/** @typedef {import('react')} React */

/**
 * @typedef NotificationContextObject
 * @property {(err: Error) => void} onError - Callback for showing recoverable errors
 */

/** @type {React.Context<NotificationContextObject>} */
export const NotificationContext = createContext();

/**
 * Custom hook to retrieve and memoize flow configuration based on URL parameters.
 *
 * @returns {NotificationContextObject}
 */
export function useNotification() {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      'useNotification must be utilized within the #client/App/NotificationManager context provider'
    );
  }
  return context;
}
